export const formatDate = (date: Date) =>
  date.toLocaleTimeString("en-US", {
    day: "2-digit",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  })
